module.exports = __webpack_public_path__ + "static/media/img_promotion_2.cc6a95b5.png";